<div class="title">
    {{ "widget_product_settings_gallery" | translate | uppercase }}
</div>

<div class="form-row">
    @if (!isPreviewSettings) {
        @if (cardKindViewType !== cardKindViewTypeOptions.sixth && cardKindViewType !== cardKindViewTypeOptions.fifth) {
            <div class="form-group mb-20">
                <label class="col-xs-12">{{ "widget_product_settings_attachment_label" | translate }}</label>
                <div class="col-xs-12">
                    <select class="form-control" [formControl]="attachment">
                        @for (option of attachmentOptions; track option) {
                            <option [selected]="attachment.value === option" [value]="option">
                                {{ option | translate }}
                            </option>
                        }
                    </select>
                </div>
            </div>
        }
        @if (cardKindViewType !== cardKindViewTypeOptions.fifth) {
            <div class="form-group mb-20">
                <label class="col-xs-12">{{ "widget_product_settings_aspect_label" | translate }}</label>
                <div class="col-xs-12">
                    <select class="form-control" [formControl]="aspectRatio" (change)="setRatio($event)">
                        @for (option of aspectRatioOptions; track option) {
                            <option [selected]="aspectRatio.value === option" [value]="option">
                                {{ option | translate }}
                            </option>
                        }
                    </select>
                </div>
            </div>
        }
        @if (
            cardKindViewType === cardKindViewTypeOptions.first || cardKindViewType === cardKindViewTypeOptions.second
        ) {
            <div class="form-group mb-20">
                <label class="col-xs-9 control-label">
                    {{ "control_background_color" | translate }}
                </label>
                <div class="col-xs-3">
                    <sp-color-picker
                        [color]="backgroundColor.value"
                        [colorsPreset]="selectedThemeColors()"
                        (colorChangeEvent)="setThemeBackgroundColor($event)"
                    ></sp-color-picker>
                </div>
            </div>
        }
        <div class="form-group mb-20">
            <label class="col-xs-6 control-label">
                {{ "control_radius" | translate }}
            </label>
            <div class="col-xs-6">
                <sp-input-num
                    prefixImgUrl="./assets/img/border-radius-icon.svg"
                    suffixText="px"
                    [min]="BORDER_RADIUS_MIN"
                    [max]="BORDER_RADIUS_MAX"
                    [value]="borderRadius.value"
                    (valueChange)="setBorderRadius($event)"
                    (blurEvent)="setBorderRadius($event)"
                ></sp-input-num>
            </div>
        </div>
        <!--    <div class="form-group mb-20">-->
        <!--        <label class="col-xs-7 control-label">-->
        <!--            {{ "control_margin" | translate }}-->
        <!--        </label>-->
        <!--        <div class="col-xs-5">-->
        <!--            <sp-input-num-->
        <!--                suffixText="px"-->
        <!--                [min]="MARGIN_MIN"-->
        <!--                [max]="MARGIN_MAX"-->
        <!--                [value]="margin.value"-->
        <!--                (valueChange)="setMargin($event)"-->
        <!--                (blurEvent)="setMargin($event)"-->
        <!--            ></sp-input-num>-->
        <!--        </div>-->
        <!--    </div>-->
        @if (
            cardKindViewType === cardKindViewTypeOptions.first || cardKindViewType === cardKindViewTypeOptions.second
        ) {
            <div class="form-group mb-20">
                <label class="col-xs-9 control-label">
                    {{ "control_arrow_color" | translate }}
                </label>
                <div class="col-xs-3">
                    <sp-color-picker
                        [hideGradient]="true"
                        [color]="buttonColor.value"
                        [colorsPreset]="selectedThemeColors()"
                        (colorChangeEvent)="setThemeButtonColor($event)"
                    ></sp-color-picker>
                </div>
            </div>
        }
        @if (
            cardKindViewType === cardKindViewTypeOptions.first || cardKindViewType === cardKindViewTypeOptions.second
        ) {
            <div class="form-group mb-20">
                <label class="col-xs-9 control-label">
                    {{ "control_arrow_background" | translate }}
                </label>
                <div class="col-xs-3">
                    <sp-color-picker
                        [hideGradient]="true"
                        [color]="buttonBackground.value"
                        [colorsPreset]="selectedThemeColors()"
                        (colorChangeEvent)="setThemeButtonBackground($event)"
                    ></sp-color-picker>
                </div>
            </div>
        }
        @if (
            cardKindViewType === cardKindViewTypeOptions.first || cardKindViewType === cardKindViewTypeOptions.second
        ) {
            <div class="form-group mb-20">
                @if (cardKindViewType === cardKindViewTypeOptions.first) {
                    <label class="col-xs-9 control-label">
                        {{ "control_pagination_color" | translate }}
                    </label>
                }
                @if (cardKindViewType === cardKindViewTypeOptions.second) {
                    <label class="col-xs-9 control-label">
                        {{ "control_thumbs_color" | translate }}
                    </label>
                }
                <div class="col-xs-3">
                    <sp-color-picker
                        [hideGradient]="true"
                        [color]="paginationColor.value"
                        [colorsPreset]="selectedThemeColors()"
                        (colorChangeEvent)="setThemePaginationColor($event)"
                    ></sp-color-picker>
                </div>
            </div>
        }
        @if (
            cardKindViewType === cardKindViewTypeOptions.first || cardKindViewType === cardKindViewTypeOptions.second
        ) {
            <div class="form-group mb-20">
                <label class="col-xs-9 control-label">
                    {{ "control_auto_slide" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [control]="changeSlide"></sp-switch>
                </div>
            </div>
        }
        <div class="form-group mb-0">
            <label class="col-xs-9 control-label">
                {{ "control_full_size" | translate }}
            </label>
            <div class="col-xs-3 text-right">
                <sp-switch [control]="fullByClick"></sp-switch>
            </div>
        </div>
    }

    @if (isPreviewSettings) {
        <div class="form-group mb-20">
            <label class="col-xs-12">{{ "widget_product_settings_attachment_label" | translate }}</label>
            <div class="col-xs-12">
                <select class="form-control" [formControl]="attachment">
                    @for (option of attachmentOptions; track option) {
                        <option [selected]="attachment.value === option" [value]="option">
                            {{ option | translate }}
                        </option>
                    }
                </select>
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-12">{{ "widget_product_settings_aspect_label" | translate }}</label>
            <div class="col-xs-12">
                <select class="form-control" [formControl]="aspectRatio" (change)="setRatio($event)">
                    @for (option of aspectRatioOptions; track option) {
                        <option [selected]="aspectRatio.value === option" [value]="option">
                            {{ option | translate }}
                        </option>
                    }
                </select>
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_background_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker
                    [color]="backgroundColor.value"
                    [colorsPreset]="selectedThemeColors()"
                    (colorChangeEvent)="setThemeBackgroundColor($event)"
                ></sp-color-picker>
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-6 control-label">
                {{ "control_radius" | translate }}
            </label>
            <div class="col-xs-6">
                <sp-input-num
                    prefixImgUrl="./assets/img/border-radius-icon.svg"
                    suffixText="px"
                    [min]="BORDER_RADIUS_MIN"
                    [max]="BORDER_RADIUS_MAX"
                    [value]="borderRadius.value"
                    (valueChange)="setBorderRadius($event)"
                    (blurEvent)="setBorderRadius($event)"
                ></sp-input-num>
            </div>
        </div>
    }

    <div class="form-group mb-0">
        <div class="col-xs-12">
            <hr class="panel-options-divider" />
        </div>
    </div>
</div>
